import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storedValue = localStorage.getItem("isLoggedIn");
    return storedValue ? JSON.parse(storedValue) : false;
  });

  const [customSession, setCustomSession] = useState(() => {
    const storedSession = localStorage.getItem("customSession");
    return storedSession ? new Date(storedSession) : null;
  });

  useEffect(() => {
    localStorage.setItem("isLoggedIn", JSON.stringify(isLoggedIn));
  }, [isLoggedIn]);

  useEffect(() => {
    if (customSession) {
      localStorage.setItem("customSession", customSession.toString());
    }
  }, [customSession]);

  const isSessionExpired = () => {
    if (!customSession) {
      return true;
    }

    const expirationTime = new Date(customSession);
    expirationTime.setHours(expirationTime.getHours() + 1);
    expirationTime.setMinutes(expirationTime.getMinutes() + 30);

    const currentTime = new Date();
    return currentTime > expirationTime;
  };

  const values = {
    isLoggedIn,
    setIsLoggedIn,
    customSession,
    setCustomSession,
    isSessionExpired,
  };

  return (
    <AuthContext.Provider value={values}>
      {children}
    </AuthContext.Provider>
  );
};
